"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyMultiAttack = void 0;
const __1 = require("../..");
const Calculators_1 = require("../state/Calculators");
function applyMultiAttack(args) {
    const { attackerId, attackType, abilityKey, targets, onDamage, onHit, onMiss, onBuffApplied, onDebuffApplied, onDebuffResisted, onCompleted, onHitOrMiss } = args;
    if (targets.length === 0) {
        return;
    }
    let { sequence } = args;
    targets.forEach((target, i) => {
        // we can't attack if we're dead, or can we?!
        if (this.isDeceased(attackerId)) {
            return;
        }
        const innerSequence = sequence.pushSequence("sequential");
        if (target.jitter > 0) {
            innerSequence.push(__1.DelayVfxStepArgs.ms(target.jitter));
        }
        this.applyAttack({
            attackerId,
            type: i === 0 ? attackType
                : (0, Calculators_1.mkAttackTypeTick)(attackType),
            abilityKey,
            targetId: target.targetId,
            sequence: innerSequence,
            onHit: (hitSequence, _, attack) => {
                if (i === 0) {
                    sequence = hitSequence.pushSequence("parallel");
                }
                hitSequence = hitSequence.pushSequence("sequential");
                onHit === null || onHit === void 0 ? void 0 : onHit(hitSequence, target, attack);
                onHitOrMiss === null || onHitOrMiss === void 0 ? void 0 : onHitOrMiss(hitSequence, target, attack);
                const { applied } = this.applyAttackDamages({
                    attackType,
                    attackerId,
                    targetId: target.targetId,
                    isCrit: attack.crit,
                    sequence: hitSequence,
                    toApply: target.damages
                });
                const damages = applied;
                onDamage === null || onDamage === void 0 ? void 0 : onDamage(hitSequence, target, attack, damages);
                const effects = target.effects || [];
                effects.filter(effect => effect.effect.harmful)
                    .forEach(debuff => {
                    this.applyDebuff({
                        attackerId,
                        sequence: hitSequence,
                        onApplied(debuffSequence) {
                            onDebuffApplied === null || onDebuffApplied === void 0 ? void 0 : onDebuffApplied(debuffSequence, target, debuff);
                        },
                        onResisted(resistedSequence) {
                            onDebuffResisted === null || onDebuffResisted === void 0 ? void 0 : onDebuffResisted(resistedSequence, target, debuff);
                        },
                        ...debuff
                    });
                });
                effects.filter(effect => !effect.effect.harmful)
                    .forEach(buff => {
                    this.applyBuff({
                        creatorId: attackerId,
                        sequence: hitSequence,
                        onApplied(appliedSequence) {
                            onBuffApplied === null || onBuffApplied === void 0 ? void 0 : onBuffApplied(appliedSequence, target, buff);
                        },
                        ...buff
                    });
                });
            },
            onMiss: (missSequence, _, attack) => {
                if (i === 0) {
                    sequence = missSequence.pushSequence("parallel");
                }
                missSequence = missSequence.pushSequence("sequential");
                onMiss === null || onMiss === void 0 ? void 0 : onMiss(missSequence, target, attack);
                onHitOrMiss === null || onHitOrMiss === void 0 ? void 0 : onHitOrMiss(missSequence, target, attack);
            }
        });
    });
    onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(sequence);
}
exports.applyMultiAttack = applyMultiAttack;
